function price2Digits(price: number) {
    return `${price.toFixed(2).replace('.', ',')}`;
}

export default {
    price2Digits
}
  